import { render, staticRenderFns } from "./loading3-component.vue?vue&type=template&id=0a3d31a4&lang=html"
import script from "./loading3-component.vue?vue&type=script&lang=js"
export * from "./loading3-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports